// Helper function to get padding
const getTextfieldLabelFontSize = size => {
  switch (size) {
    case 'small':
      return '12px'
    case 'large':
      return '16px'
    case 'medium':
    default:
      return '14px'
  }
}

export default getTextfieldLabelFontSize
